import {getSessionConfig} from './sessionConfig'

export function getDateFormat() {
  return getSessionConfig().dateFormat
}

export function getIntlDateFormat() {
  return getSessionConfig().dateFormat === 'MM/DD/YYYY' ? 'en-US' : 'en-GB'
}

export function getTimeFormat() {
  return getSessionConfig().timeFormat
}

export function getNumberFormat() {
  return getSessionConfig().numberFormat
}

export function getDecimalSeparator() {
  return getNumberFormat() === 'eu' ? ',' : '.'
}
